import React, { Component } from 'react';
import './style.css';
import dashboard from '../../pages/dashboard';

class Dashboard extends Component {
  constructor(props){
    super(props)
    this.state={

    };
  }

  render(){
        let viewHtml = "";

        if(this.props.success && this.props.dashboardData){

          viewHtml = <div className = "dashbords">
            
               <div className = "totalmembers">
                <label id = "ds1">Total Members</label>
                <div className = "class1">
                  <span id = "dss2">{this.props.dashboardData.data.members}</span>
                </div>
              </div>
            
              <div className = "totallivestudent"> 
              <label id = "ds2">Total Live Studies</label>
                <div className = "class2">
                  <span id = "dss1">{this.props.dashboardData.data.studies}</span>
                </div>
              </div>

              <div className = "totalmembers mt10">
                <label id = "ds1">Total Current Month Members</label>
                <div className = "class1">
                  <span id = "dss2">{this.props.dashboardData.data.currentMonthUserCount}</span>
                </div>
              </div>
            
              <div className = "totallivestudent mt10"> 
              <label id = "ds2">Total Current Day Members</label>
                <div className = "class2">
                  <span id = "dss1">{this.props.dashboardData.data.todayUserCount}</span>
                </div>
              </div>

          </div>
        }else{
          viewHtml = <p>The members and live study are not found</p>
        }
    

    return (
    <div className = "pagedashbord">
    <div className = "dashbordpage">
         <div className = "dashborddata"> <h1>Dashboard Data</h1></div>
         <div className = "datalist">
          {viewHtml}</div>
        </div>
        </div>
    );
  }
}
export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/index.js